import { render } from "./PhotoGalleries-page.vue?vue&type=template&id=02494e85&scoped=true"
import script from "./PhotoGalleries-page.vue?vue&type=script&lang=js"
export * from "./PhotoGalleries-page.vue?vue&type=script&lang=js"

import "./PhotoGalleries-page.vue?vue&type=style&index=0&id=02494e85&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02494e85"]])

export default __exports__